import styled from "styled-components";

import * as css from "styles/CssVariables.js";
import globalConstants from "constants/globalConstants";
import { numberWithCommas } from "modules/functions";

import profileImage from "assets/img/landingPage/mockup-profile-image.png";
import dollarAffiliateProgramIcon from "assets/img/icons/dollar-icon-affiliate-program.svg";
import directReferralsIcon from "assets/img/icons/direct-referrals-icon.svg";
import indirectReferralsGroupIcon from "assets/img/icons/indirect-referrals-group-icon.svg";
import indirectReferralsIcon from "assets/img/icons/indirect-referrals-icon.svg";
import dollarIcon from "assets/img/icons/dollar-icon.svg";
import referralsQualifiedIcon from "assets/img/icons/referral-qualified-icon.svg";
import percentIcon from "assets/img/icons/percent-icon.svg";
import revenueIcon from "assets/img/icons/Subscription-Cashflow--Streamline-Core.svg";
import referralsIcon from "assets/img/icons/referrals-icon.svg";
import emptyIcon from "assets/img/icons/empty-icon.svg";

const AffiliateProgram = styled.div`
  position: absolute;
  top: 36px;
  left: 0;
  width: 100%;
  box-sizing: border-box;

  margin: 0;
  padding: 0 7px;

  display: flex;
  flex-direction: column;

  opacity: ${(props) => (props.display ? 100 : 0)};

  transition: 0.2s;
`;

const AffiliateProgramBox = styled.div`
  width: 100%;
  padding: 10px 9px 15px;
  box-sizing: border-box;
  margin-top: 8px;

  background: ${css.BLUE_BOX_GRADIENT};
  border-radius: 10px;

  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const BoxTitle = styled.div`
  width: 100%;

  line-height: 130%;

  font-size: 13px;
  font-weight: ${css.BOX_TITLE_FONT_WEIGHT};
`;

const DollarIcon = styled.div`
  display: inline-block;
  padding-right: 4px;

  transform: translateY(4.5px);

  width: 18px;
  min-width: 18px;
`;

const Schema = styled.div`
  margin: 5px 0;

  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
`;

const SchemaProfilePicture = styled.div`
  width: 38px;
  min-width: 38px;
  height: 38px;
`;

const AvatarImage = styled.img`
  width: 100%;
  border-radius: 50%;
`;

const SchemaGraphics = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const SchemaLevel = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
`;

const SchemaLevelText = styled.div`
  width: 130px;

  font-size: 13px;
  font-weight: 500;
`;

const SchemaLevelRight = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`;

const SchemaWrap = styled.div`
  min-width: 47px;

  @media (max-width: ${globalConstants.switchMobile}) {
    min-width: 0px;
  }
`;

const SchemaIcon = styled.div`
  height: 18px;
`;

const SchemaRateBox = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

const SchemaRateCashIcon = styled.div`
  width: 20px;
  min-width: 20px;
  height: 20px;
`;

const SchemaRateText = styled.div`
  font-size: 13px;
  font-weight: 500;
  white-space: nowrap;
`;

const OverviewData = styled.div`
  display: flex;
  gap: 15px;
  flex-wrap: wrap;
`;

const Data = styled.div`
  font-size: 12px;

  display: flex;
  flex-direction: column;
  gap: 3px;
`;

const DataTitle = styled.div`
  font-weight: 500;

  display: flex;
  align-items: center;
  gap: 6px;
`;

const DataRow = styled.div`
  display: flex;
  align-items: center;
  gap: 7px;
`;

const DataIconBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const DataIcon = styled.div`
  width: 18px;
  min-width: 18px;
  height: 18px;
`;

const DataText = styled.div`
  white-space: nowrap;
`;

const StatsBoxes = styled.div`
  margin-top: 3px;

  display: flex;
  gap: 20px;
  flex-wrap: wrap;
`;

const StatsBoxTitle = styled.div`
  width: 100%;

  font-size: 13px;
  font-weight: 500;
`;

const AffiliateStats = styled.div`
  max-width: 100%;

  display: flex;
  flex-direction: column;
  gap: 7px;

  flex: 1;
`;

const StatsBox = styled.div`
  padding: 15px 10px 15px;
  width: 100%;

  box-sizing: border-box;

  background: ${css.FLAT_BOX_BACKGROUND};
  border-radius: 10px;
`;

const TableWrap = styled.div`
  width: 100%;
  padding-bottom: 5px;
  margin-bottom: -5px;

  overflow-x: auto;
`;

const StatsBoxGrid = styled.div`
  display: grid;
  grid-template-columns: 110px 73px 73px;
  grid-template-rows: 20px 20px 20px 20px 20px 20px;
  grid-gap: 4px 7px;
`;

const StatsLabel = styled.div`
  font-size: 13px;
  font-weight: 500;
`;

const LabelIconCell = styled.div`
  font-size: 13px;

  display: flex;
  align-items: center;
  gap: 8px;
`;

const LabelIcon = styled.div`
  width: 14px;
  min-width: 14px;
  height: 14px;
`;

const LabelText = styled.div`
  font-size: 13px;
  font-weight: 300;
`;

const ValueCell = styled.div`
  height: 24px;

  font-size: 13px;
  white-space: nowrap;

  display: flex;
  align-items: center;
`;

const ValueIconCell = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const ValueIcon = styled.div`
  width: 20px;
  min-width: 20px;
  height: 20px;
`;

const EarningsHistory = styled.div`
  min-width: 215px;

  display: flex;
  flex-direction: column;
  gap: ${css.VERTICAL_BOX_MARGIN};

  flex: 0.65;
`;

const EarningsBox = styled.div`
  padding: 15px 20px;
  width: 100%;
  height: 100%;
  box-sizing: border-box;

  background: ${css.FLAT_BOX_BACKGROUND};
  border-radius: ${css.BOX_RADIUS_SECONDARY};

  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr 1fr 1fr 1fr 1fr;
  grid-gap: 8px 15px;
`;

const Empty = styled.div`
  padding: 30px 0;

  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;

  grid-column-start: 1;
  grid-column-end: 3;
  grid-row-start: 2;
  grid-row-end: 7;
`;

const EmptyIcon = styled.div`
  width: 26px;
  min-width: 26px;
  height: 26px;
`;

const EmptyText = styled.div`
  text-align: center;
`;

export default ({ display }) => {
  return (
    <AffiliateProgram display={display}>
      <AffiliateProgramBox>
        <BoxTitle>
          <DollarIcon>
            <img src={dollarAffiliateProgramIcon} style={{ width: "100%" }} />
          </DollarIcon>
          Create Steady Residual Income
        </BoxTitle>
        <Schema>
          <SchemaProfilePicture>
            <AvatarImage src={profileImage} style={{ width: "100%" }} />
          </SchemaProfilePicture>
          <SchemaGraphics>
            <SchemaLevel>
              <SchemaLevelText>Direct Referrals</SchemaLevelText>
              <SchemaLevelRight>
                <SchemaWrap>
                  <SchemaIcon>
                    <img src={directReferralsIcon} style={{ height: "100%" }} />
                  </SchemaIcon>
                </SchemaWrap>
                <SchemaRateBox>
                  <SchemaRateCashIcon>
                    <img src={dollarIcon} style={{ height: "100%" }} />
                  </SchemaRateCashIcon>
                  <SchemaRateText>40% - 50%</SchemaRateText>
                </SchemaRateBox>
              </SchemaLevelRight>
            </SchemaLevel>
            <SchemaLevel>
              <SchemaLevelText>Indirect Referrals</SchemaLevelText>
              <SchemaLevelRight>
                <SchemaWrap>
                  <SchemaIcon>
                    <img
                      src={indirectReferralsGroupIcon}
                      style={{ height: "100%" }}
                    />
                  </SchemaIcon>
                </SchemaWrap>
                <SchemaRateBox>
                  <SchemaRateCashIcon>
                    <img src={dollarIcon} style={{ height: "100%" }} />
                  </SchemaRateCashIcon>
                  <SchemaRateText>5%</SchemaRateText>
                </SchemaRateBox>
              </SchemaLevelRight>
            </SchemaLevel>
          </SchemaGraphics>
        </Schema>
        <>
          <OverviewData>
            <Data>
              <DataTitle>Direct Referrals</DataTitle>
              <DataRow>
                <DataIconBox>
                  <DataIcon>
                    <img src={referralsIcon} style={{ width: "100%" }} />
                  </DataIcon>
                </DataIconBox>
                <DataText>{numberWithCommas(174)}</DataText>
              </DataRow>
            </Data>
            <Data>
              <DataTitle>Indirect Referrals</DataTitle>
              <DataRow>
                <DataIconBox>
                  <DataIcon>
                    <img
                      src={indirectReferralsIcon}
                      style={{ width: "100%" }}
                    />
                  </DataIcon>
                </DataIconBox>
                <DataText>{numberWithCommas(357)}</DataText>
              </DataRow>
            </Data>
            <Data>
              <DataTitle>Total Commissions Earned</DataTitle>
              <DataRow>
                <DataIconBox>
                  <DataIcon>
                    <img src={dollarIcon} style={{ width: "100%" }} />
                  </DataIcon>
                </DataIconBox>
                <DataText>{numberWithCommas(13788)} USD</DataText>
              </DataRow>
            </Data>
          </OverviewData>
          <StatsBoxes>
            <AffiliateStats>
              <StatsBoxTitle>Referrals and Rewards</StatsBoxTitle>
              <StatsBox>
                <TableWrap className="table-wrap">
                  <StatsBoxGrid>
                    <StatsLabel>Data</StatsLabel>
                    <StatsLabel>This Month</StatsLabel>
                    <StatsLabel>Last Month</StatsLabel>
                    <LabelIconCell>
                      <LabelIcon>
                        <img src={revenueIcon} style={{ width: "100%" }} />
                      </LabelIcon>
                      <LabelText>Direct Revenue</LabelText>
                    </LabelIconCell>
                    <ValueCell>${numberWithCommas(984)}</ValueCell>
                    <ValueCell>${numberWithCommas(3710)}</ValueCell>
                    <LabelIconCell>
                      <LabelIcon>
                        <img src={percentIcon} style={{ width: "100%" }} />
                      </LabelIcon>
                      <LabelText>Direct Rate</LabelText>
                    </LabelIconCell>
                    <ValueCell>{40}%</ValueCell>
                    <ValueCell>{45}%</ValueCell>
                    <LabelIconCell>
                      <LabelIcon>
                        <img src={revenueIcon} style={{ width: "100%" }} />
                      </LabelIcon>
                      <LabelText>Indirect Rev.</LabelText>
                    </LabelIconCell>
                    <ValueCell>${numberWithCommas(1722)}</ValueCell>
                    <ValueCell>${numberWithCommas(7225)}</ValueCell>
                    <LabelIconCell>
                      <LabelIcon>
                        <img src={percentIcon} style={{ width: "100%" }} />
                      </LabelIcon>
                      <LabelText>Indirect Rate</LabelText>
                    </LabelIconCell>
                    <ValueCell>{5}%</ValueCell>
                    <ValueCell>{5}%</ValueCell>
                    <LabelIconCell>
                      <LabelIcon>
                        <img src={dollarIcon} style={{ width: "100%" }} />
                      </LabelIcon>
                      <LabelText>Commissions</LabelText>
                    </LabelIconCell>
                    <ValueCell>${numberWithCommas(480)}</ValueCell>
                    <ValueCell>${numberWithCommas(2031)}</ValueCell>
                  </StatsBoxGrid>
                </TableWrap>
              </StatsBox>
            </AffiliateStats>
            {/* <EarningsHistory>
              <StatsBoxTitle>Earnings History</StatsBoxTitle>
              <EarningsBox>
                <StatsLabel>Month</StatsLabel>
                <StatsLabel>Earned</StatsLabel>
                {list}
                {list.length === 0 && (
                  <Empty>
                    <EmptyIcon>
                      <img src={emptyIcon} style={{ width: "100%" }} />
                    </EmptyIcon>
                    <EmptyText>No earnings yet</EmptyText>
                  </Empty>
                )}
              </EarningsBox>
            </EarningsHistory> */}
          </StatsBoxes>
        </>
      </AffiliateProgramBox>
    </AffiliateProgram>
  );
};
